<script context="module">/**
 * This import is used by the Svelte SDK. Do not remove.
 */
</script>

<script>import { isEditing } from "../../../functions/is-editing";
import { filterAttrs } from "../../helpers";
import { setAttrs } from "../../helpers";
export let attributes = undefined;
export let value = undefined;
export let defaultValue = undefined;
export let name = undefined;
export let required = undefined;
export let options = undefined;
</script>

<select
  {...filterAttrs(attributes, "on:", false)}
  {value}
  key={isEditing() && defaultValue ? defaultValue : "default-key"}
  {defaultValue}
  {name}
  {required}
  use:setAttrs={filterAttrs(attributes, "on:", true)}
>
  {#each options as option, index (`${option.name}-${index}`)}
    <option value={option.value}>{option.name || option.value}</option>
  {/each}
</select>